import {PureComponent} from 'react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'
import ArrowLeft from 'react-feather/dist/icons/arrow-left.js'
import ChevronLeft from 'react-feather/dist/icons/chevron-left.js'
import ChevronRight from 'react-feather/dist/icons/chevron-right.js'

import './SearchNavbar.scss'

export default class SearchNavbar extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    currentPosition: PropTypes.number.isRequired,
    nextLink: PropTypes.string,
    prevLink: PropTypes.string,
    searchLink: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired
  }

  render() {
    return (
      <div className={`search-navbar-extension ${this.props.className}`}>
        <Link to={this.props.searchLink} className="back br">
          <ArrowLeft className="nav-icon"/>
          Retour à la recherche
        </Link>
        <div className="name br">
          <div className="w-100 text-center">
            {this.props.children}
          </div>
        </div>
        <div className="controls">
          <Link to={this.props.prevLink || ''} disabled={!this.props.prevLink} className="left br">
            <ChevronLeft className="nav-icon"/>
          </Link>
          <div className="position br">
            {this.props.currentPosition}/{this.props.total}
          </div>
          <Link to={this.props.nextLink || ''} disabled={!this.props.nextLink} className="left br">
            <ChevronRight className="nav-icon"/>
          </Link>
        </div>
      </div>
    )
  }
}
